import axios from "../../axiosDod.js";
import router from "../../router/index.js";
import Vue from "vue";

const getEmployeeSettlement = async (_ctx, { employeeId, month, year }) => {
  const response = await axios.get(`settlements/employee/${employeeId}`, {
    params: { month, year },
  });
  return response.data;
};

const saveSettlementDraft = async (_ctx, { employeeId, month, year, tables }) => {
  const response = await axios.put(
    `settlements/employee/${employeeId}/draft`,
    { tables },
    { params: { month, year } }
  );
  return response.data;
};

const submitSettlement = async (_ctx, { employeeId, month, year, draft }) => {
  const response = await axios.post(
    `settlements/employee/${employeeId}/submit`,
    draft ? { draft } : {},
    { params: { month, year } }
  );
  return response.data;
};

const settleSettlement = async (_ctx, { employeeId, month, year, draft }) => {
  const response = await axios.post(
    `settlements/employee/${employeeId}/settle`,
    draft ? { draft } : {},
    { params: { month, year } }
  );
  return response.data;
};

const returnSettlementToFix = async (_ctx, { employeeId, month, year }) => {
  const response = await axios.post(
    `settlements/employee/${employeeId}/return`,
    {},
    { params: { month, year } }
  );
  return response.data;
};

const getSettlementHistory = async (_ctx, { employeeId, month, year }) => {
  const response = await axios.get(
    `settlements/employee/${employeeId}/history`,
    { params: { month, year } }
  );
  return response.data;
};

const getSettlementHistoryEntry = async (_ctx, entryId) => {
  const response = await axios.get(`settlements/history/${entryId}`);
  return response.data;
};

const getSettlementStatusesByEmployees = async (
  _ctx,
  { employeeIds, month, year }
) => {
  if (!employeeIds || employeeIds.length === 0) {
    return [];
  }
  const params = { employeeIds };
  if (month && year) {
    params.month = month;
    params.year = year;
  }
  const response = await axios.get(`settlements/statuses/byEmployees`, {
    params,
  });
  return response.data;
};

const fetchSettlementCounters = async ({ commit }, { month, year }) => {
  const response = await axios.get(`settlements/counters`, {
    params: { month, year },
  });
  commit("SET_SETTLEMENT_COUNTERS", response.data);
  return response.data;
};

const getPanelUserRoles = async () => {
  const response = await axios.get(`panelUserRoles`);
  return response.data;
};

const setPanelUserRole = async (_ctx, { adminPhone, role, adminName }) => {
  const response = await axios.put(`panelUserRoles`, {
    adminPhone,
    role,
    adminName,
  });
  return response.data;
};

const blockPanelUserAccess = async (_ctx, { adminPhone }) => {
  const response = await axios.post(`panelUserRoles/blockAccess`, { adminPhone });
  return response.data;
};

// Guard: przy self-heal (interceptor axiosDod) wiele udanych calli DOD mogloby odpalic
// rownolegle wiele /me zanim pierwsze wroci. Pozwalamy tylko jednemu naraz.
let myPanelRoleFetchInFlight = false;
const fetchMyPanelRole = async ({ commit }) => {
  if (myPanelRoleFetchInFlight) return;
  myPanelRoleFetchInFlight = true;
  try {
    const response = await axios.get(`panelUserRoles/me`);
    commit("SET_MY_PANEL_ROLE", response.data ? response.data.role : null);
    return response.data;
  } catch (error) {
    commit("SET_MY_PANEL_ROLE", null);
    console.log(error);
  } finally {
    myPanelRoleFetchInFlight = false;
  }
};

// Reaction to a 403 DOD_ACCESS_REVOKED from any DOD call: disable the DOD module
// WITHOUT logging the user out of the main SeniorApp admin panel (shared app).
// - ACTIVELY inside DOD (on a DOD route): exit DOD view, notify once, bounce to the
//   main users list. Header reacts to the flag and flips its nav/switch back.
// - BACKGROUND 403 (not on a DOD route, e.g. the login-time notifications poll):
//   silently disable DOD - no toast, don't move the user.
const handleDodAccessRevoked = ({ commit, getters, dispatch }) => {
  const firstTime = !getters.getDodAccessRevoked;
  commit("SET_DOD_ACCESS_REVOKED", true);
  commit("SET_MY_PANEL_ROLE", null);
  const current = router.currentRoute;
  const onDodRoute = !!(current && current.meta && current.meta.isDodRoute);
  if (onDodRoute) {
    // Leave the DOD panel back to the main app panel (updates activePanel + the
    // legacy DODView compat flag). POD access, if any, is unaffected.
    dispatch("setActivePanel", "MAIN_APP");
    if (firstTime) {
      Vue.notify({
        group: "error",
        text:
          "Twój dostęp do panelu DOD został zablokowany. Moduł DOD jest niedostępny.",
      });
    }
    router.push("/users").catch(() => {});
  }
};

export default {
  getEmployeeSettlement,
  saveSettlementDraft,
  submitSettlement,
  settleSettlement,
  returnSettlementToFix,
  getSettlementHistory,
  getSettlementHistoryEntry,
  getSettlementStatusesByEmployees,
  fetchSettlementCounters,
  getPanelUserRoles,
  setPanelUserRole,
  blockPanelUserAccess,
  fetchMyPanelRole,
  handleDodAccessRevoked,
};
